import React from "react";
import { BarChartFill, StopFill } from "react-bootstrap-icons";
import AnalyticsSurface from "./AnalyticsSurface";

export const AssistantAvatar = () => (
  <span className="analytics-avatar" aria-hidden="true">
    <BarChartFill size={15} />
  </span>
);

// One conversation turn as chat: the user's question on the right, the
// assistant's reply (narrative, chart/table, status) on the left. Charts live
// inside the reply bubble so they stay part of the conversation.
const ChatMessage = ({ turn, surface, onStop }) => {
  const working = turn.status === "sending" || turn.status === "streaming";
  const empty = !turn.narrative && !surface && !turn.refusal;

  return (
    <div className="analytics-msg">
      <div className="analytics-msg-user">
        <div className="analytics-bubble analytics-bubble--user">{turn.question}</div>
      </div>

      <div className="analytics-msg-ai">
        <AssistantAvatar />
        <div className={`analytics-bubble analytics-bubble--ai${surface ? " has-surface" : ""}`}>
          {working && empty && (
            <span className="analytics-typing" role="status" aria-label="Assistant is thinking">
              <i /><i /><i />
            </span>
          )}

          {turn.narrative && <p className="analytics-chat-narrative">{turn.narrative}</p>}

          {surface && <AnalyticsSurface surface={surface} />}

          {turn.refusal && <p className="analytics-chat-narrative mb-0">{turn.refusal}</p>}

          {turn.status === "streaming" && (
            <div className="mt-2">
              <button
                type="button"
                className="analytics-chat-stop-btn"
                title="Stop this question"
                onClick={() => onStop?.(turn)}
              >
                <StopFill size={12} className="me-1" />
                Stop
              </button>
            </div>
          )}

          {turn.status === "stopped" && <div className="text-muted small fst-italic">Stopped.</div>}

          {turn.status === "error" && (
            <div className="text-danger small">Something went wrong with this question.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
